import { render, staticRenderFns } from "./myApproval.vue?vue&type=template&id=c9ac4a0a&scoped=true&lang=pug"
import script from "./myApproval.vue?vue&type=script&lang=js"
export * from "./myApproval.vue?vue&type=script&lang=js"
import style0 from "./myApproval.vue?vue&type=style&index=0&id=c9ac4a0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ac4a0a",
  null
  
)

export default component.exports